"use client";

import { Hamburguer } from "@/components/util";
import { HeaderBrand } from "./header-brand";
import { HeaderNav } from "./header-nav";
import { useHeader } from "./use-header";

export const Header = () => {
  const { headerRef, styles, onToggleMenu, opened } = useHeader();

  return (
    <header ref={headerRef} className={styles.base()}>
      <div className={styles.bar()}>
        <HeaderBrand styles={styles} />
        <HeaderNav styles={styles} />
        <Hamburguer
          active={opened}
          className="desktop:hidden"
          toggle={() => onToggleMenu(!opened)}
          ariaControls="header-nav"
        />
      </div>
    </header>
  );
};
